export default [
    {
        path: '/data-link-multi',
        name: 'dataLinkMultiList',
        component: () => import('@/views/share/listMultiShare')
    },
    {
        path: '/data-link-multi/edit',
        name: 'editDataLinkMulti',
        component: () => import('@/views/share/add')
    },
    {
        path: '/data-link-multi/view',
        name: 'viewDataLinkMulti',
        component: () => import('@/views/share/listShare')
    },
    {
        path: '/data-link-multi/data-view',
        name: 'dataLinkMultiDataView',
        component: () => import('@/views/share/dataView/list/index.vue')
    },
    {
        path: '/data-link-multi/data-view/create',
        name: 'dataLinkMultiDataViewCreate',
        component: () => import('@/views/share/dataView/create/index.vue')
    },
    {
        path: '/data-link-multi/data-view/detail',
        name: 'dataLinkMultiDataViewDetail',
        component: () => import('@/views/share/dataView/edit/index.vue')
    },
    {
        path: '/data-link-multi/data-view/edit',
        name: 'dataLinkMultiDataViewEdit',
        component: () => import('@/views/share/dataView/edit/index.vue')
    },
    {
        path: '/data-link-multi/data-view/edit-multiple',
        name: 'dataLinkMultiDataViewEditMultiple',
        component: () => import('@/views/share/dataView/editMultipleData')
    },
    {
        path: '/share',
        name: 'shareList',
        component: () => import('@/views/share/listShare')
    },
    {
        path: '/share/add',
        name: 'addShare',
        component: () => import('@/views/share/add')
    },
    {
        path: '/share/edit',
        name: 'editShare',
        component: () => import('@/views/share/add')
    },
    {
        path: '/share/data-view',
        name: 'dataView',
        component: () => import('@/views/share/dataView/list/index.vue')
    },
    {
        path: '/share/data-view/create',
        name: 'dataViewCreate',
        component: () => import('@/views/share/dataView/create/index.vue')
    },
    {
        path: '/share/data-view/detail',
        name: 'dataViewDetail',
        component: () => import('@/views/share/dataView/edit/index.vue')
    },
    {
        path: '/share/data-view/edit',
        name: 'dataViewEdit',
        component: () => import('@/views/share/dataView/edit/index.vue')
    },
    {
        path: '/share/data-view/edit-multiple',
        name: 'dataViewEditMultiple',
        component: () => import('@/views/share/dataView/editMultipleData')
    },
    {
        path: '/share-user-children',
        name: 'shareListUserChildren',
        component: () => import('@/views/share/listShareUser')
    },
    {
        path: '/export-user-children',
        name: 'exportListUserChildren',
        component: () => import('@/views/share/dataView/exportListUser')
    },
    {
        path: '/share-user-children/data-view',
        name: 'dataViewChildren',
        component: () => import('@/views/share/dataView/list/index.vue')
    },
    {
        path: '/share-user-children/data-view/create',
        name: 'dataViewCreateChildren',
        component: () => import('@/views/share/dataView/create/index.vue')
    },
    {
        path: '/share-user-children/data-view/detail',
        name: 'dataViewDetailChildren',
        component: () => import('@/views/share/dataView/edit/index.vue')
    },
    {
        path: '/share-user-children/data-view/edit',
        name: 'dataViewEditChildren',
        component: () => import('@/views/share/dataView/edit/index.vue')
    },
    {
        path: '/share-user-children/data-view/edit-multiple',
        name: 'dataViewEditMultipleChildren',
        component: () => import('@/views/share/dataView/editMultipleData')
    }
];
